import { keepPreviousData } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { bunja } from 'bunja';
import { atom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';

import { getMyAddressApi } from '@flipster/apis/v1/wallet';
import { GetMyAddressResponse } from '@flipster/apis/v1/wallet/type';
import { i18nBunja } from '@flipster/i18n';
import { alert } from '@flipster/ui/Alert';

import { authBunja } from '../../../auth/state';
import { v1CurrenciesBunja } from '../../../currency/use-v1-currencies';
import { walletModalBunja } from '../core/state';

export const myAddressBunja = bunja(() => {
  const { selectedCurrencyAtom, selectedNetworkAtom } = bunja.use(walletModalBunja);
  const { getT } = bunja.use(i18nBunja);
  const t = getT();
  const { userAtom, isLoggedInAtom } = bunja.use(authBunja);
  const { currenciesKeyByCurrencyAtom } = bunja.use(v1CurrenciesBunja);
  const blockchainAtom = atom((get) => {
    const currency = get(selectedCurrencyAtom) ?? '';
    const networkName = get(selectedNetworkAtom);
    const currenciesKeyByCurrency = get(currenciesKeyByCurrencyAtom);
    return currenciesKeyByCurrency?.[currency]?.blockchainInfo.find((b) => b.networkName === networkName);
  });
  const myAddressBaseAtom = atomWithQuery((get) => {
    const blockchain = get(blockchainAtom);
    const currency = get(selectedCurrencyAtom) ?? '';
    const networkName = get(selectedNetworkAtom);
    return {
      queryKey: ['getMyAddressApi', currency, networkName],
      queryFn: () =>
        getMyAddressApi({
          currency,
          blockchainName: blockchain!.blockchainName,
          blockchainAsset: blockchain!.blockchainAsset,
        }).catch((err) => {
          // TODO: check error type in runtime
          alert.show({ message: t('Deposit.r250401.Address_generation_pending_description') });
          throw err;
        }),
      select: (res: AxiosResponse<GetMyAddressResponse>) => res.data,
      enabled: get(isLoggedInAtom) && !!currency && !!blockchain,
      gcTime: 1000 * 60, // 입금 한번 더 할거 감안하여 1분으로 잡는다.
      placeholderData: keepPreviousData, // 네트워크 전환시 번쩍임 방지
      throwOnError: false, // 503이 떨어 질수 있음
    };
  });
  const userIdAtom = atom((get) => String(get(userAtom)?.userId ?? ''));
  const myAddressAtom = atom((get) => {
    const data = get(myAddressBaseAtom).data;
    return {
      address: data?.address,
      destinationTag: data?.addressParams?.destinationTag,
      memo: data?.addressParams?.memo,
    };
  });
  const isLoadingAtom = atom((get) => get(myAddressBaseAtom).isPending || get(myAddressBaseAtom).isFetching);

  return {
    userIdAtom,
    isLoadingAtom,
    myAddressAtom,
  };
});
myAddressBunja.debugLabel = 'myAddressBunja';
